import { render, staticRenderFns } from "./item-scale.vue?vue&type=template&id=06cace5f&scoped=true&"
import script from "./item-scale.vue?vue&type=script&lang=js&"
export * from "./item-scale.vue?vue&type=script&lang=js&"
import style0 from "./item-scale.vue?vue&type=style&index=0&id=06cace5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cace5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
